/**
 * @override Vimeo provider (captions + embed tweaks). YouTube uses base implementation.
 */

import {Html} from '@amblique/king-living/app/plugins/video/providers/html';
import {Youtube} from '@amblique/base/app/plugins/video/providers/youtube';

import {Vimeo} from '@amblique/king-living/app/plugins/video/providers/vimeo';

export const providers = [Html, Vimeo, Youtube];
